import React, { useState, useRef, useEffect } from 'react';
import { Info } from 'lucide-react';

/**
 * FieldInfo – kleines Info-Icon mit Popup-Text für Formular-Felder.
 * Verwendung mit Text:   <FieldInfo text="Beschreibungstext" />
 * Verwendung mit JSX:    <FieldInfo><>Text <a href="...">Link</a></></FieldInfo>
 */
const FieldInfo = ({ text, children }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [open]);

  return (
    <span
      ref={containerRef}
      style={{ position: 'relative', display: 'inline-block', verticalAlign: 'middle', marginLeft: '5px' }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Hilfe anzeigen"
        title="Mehr Informationen"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#3b82f6',
          padding: '0',
          lineHeight: 1,
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Info size={15} color="var(--Colors-Grey-06, #69757C)" />
      </button>

      {open && (
        <div
          role="tooltip"
          style={{
            position: 'absolute',
            zIndex: 1100,
            left: '50%',
            transform: 'translateX(-50%)',
            top: '22px',
            background: '#ffffff',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
            padding: '10px 14px',
            minWidth: '220px',
            maxWidth: '320px',
            fontSize: '13px',
            lineHeight: '1.55',
            color: '#374151',
            whiteSpace: 'normal',
          }}
        >
          {children ?? text}
        </div>
      )}
    </span>
  );
};

export default FieldInfo;
